import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App' //.js is the default expression

ReactDOM.render(
  <div>
    <App/>
  </div>,
  document.getElementById('root')
);
